import React from 'react';

const WhatsupBtn = () => {
  return (
    <a href="https://wa.me/6281990842718?text=Halo%20Pyro%20Games!%20Saya%20ingin%20bertanya" id='side-btn-whatsapp' target="_blank" rel="noopener noreferrer" style={styles.link}>
      <img
        src="https://storage.googleapis.com/nero-assets/socmed/wa-nerogame.gif"
        alt="WhatsApp"
        style={styles.icon}
      />
    </a>
  );
};

const styles = {
  link: {
    position: 'fixed',
    bottom: '70px',
    left: '0px',
    zIndex: 1000,
  },
  icon: {
    width: '50px', // Adjust size as needed
    height: '50px', // Adjust size as needed
  }
};

export default WhatsupBtn;
